import MobileHelper from './MobileHelper';

export const alertDialog = message => {
    if (MobileHelper.isWebView()) {
        navigator.notification.alert(
            message, // message
            () => {}, // callback
            'FMS', // title
            '확인' // buttonName
        );
    } else {
        window.alert(message);
    }
};

export const confirmDialog = (message, okCallback, cancelCallback) => {
    if (MobileHelper.isWebView()) {
        navigator.notification.confirm(
            message, // message
            buttonIndex => {
                if (buttonIndex === 1) {
                    okCallback();
                } else {
                    if (cancelCallback) cancelCallback();
                }
            }, // callback
            'FMS', // title
            ['확인', '취소'] // buttonName
        );
    } else {
        if (window.confirm(message)) {
            okCallback();
        } else {
            if (cancelCallback) cancelCallback();
        }
    }
};

export const promtDialog = (message, okCallback, defaultText) => {
    if (MobileHelper.isWebView()) {
        navigator.notification.prompt(
            message, // message
            results => {
                if (results.buttonIndex === 1) {
                    okCallback(results.input1);
                }
            }, // callback
            'CDS.LIVE', // title
            ['확인', '취소'], // buttonName
            defaultText || ''
        );
    }
};

export const exitDialog = () => {
    navigator.notification.confirm(
        '앱을 종료하시겠습니까?', // message
        buttonIndex => {
            if (buttonIndex === 1) {
                window.cordova.plugins.exit();
            }
        }, // callback
        'FMS', // title
        ['종료', '취소'] // buttonName
    );
};

export const photoDialog = (cameraCallback, galleryCallback) => {
    navigator.notification.confirm(
        '찰영 또는 갤러리를 선택하세요', // message
        buttonIndex => {
            if (buttonIndex === 1) {
                cameraCallback();
            } else {
                galleryCallback();
            }
        }, // callback
        'FMS', // title
        ['찰영', '갤러리'] // buttonName
    );
};
